const setSitesToErrorMessageModalCloneCheck = {
  errSite: 'possui um checklist.'
};

export default setSitesToErrorMessageModalCloneCheck;
